<template>
    <div class="container">
    <el-row type="flex" justify="center">
      <el-col :xs="20" :sm="18" :md="14" :lg="8">
        <registerForm></registerForm>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import registerForm from '@c/user/register/registerForm.vue'
import { mapGetters } from 'vuex'
export default {
  name: 'userLoginPage',
  components: {
    registerForm
  },
  computed: {
    ...mapGetters([ 'logined', 'username' ])
  },
  mounted () {
    // 判断是否已经登录，如果登录，直接跳转到首页
    if (this.logined) {
      this.$router.push('/qrmanage')
      this.$message.success('您已经处于登录状态，无需重新注册！')
    }
  },
  watch: {
    // 判断是否已经登录，如果登录，直接跳转到首页
    // 此处主要为了处理，有时组件mounted的时候，logined尚未更新
    logined: function (newLogined) {
      if (newLogined) {
        this.$router.push('/qrmanage')
        this.$message.success('您已经处于登录状态，无需重新注册！')
      }
    }
  }
}
</script>
